// extracted by mini-css-extract-plugin
export default {"shippingStatusContainer":"mE-z","shipmentMessage":"nE-z","shipmentNumber":"oE-z","trackingProgressContainer":"pE-z"};